import React, { useEffect, useState } from "react";

const BackToTopButton = () => {
  const [show, setShow] = useState(false);

  const toggleVisible = () => {
    const scrolled = window.scrollY;
    if (scrolled > 300) setShow(true);
    else setShow(false);
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisible);
    return () => {
      window.removeEventListener("scroll", toggleVisible);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <button
      onClick={scrollToTop}
      className={`btn btn-primary position-fixed bottom-0 end-0 m-4 rounded-circle ${
        show ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      style={{
        width: 48,
        height: 48,
        transition: "opacity .3s",
        zIndex: 1050,
      }}
      aria-label="Retour en haut"
    >
      ↑
    </button>
  );
};

export default BackToTopButton;
